import React from 'react'
import Box from './box'
import { root } from './variables'
import merge from 'deepmerge'

interface IGrid {
  css?: {}
  fluid?: boolean
  maxWidth?: number
}

class Container extends React.Component<IGrid, any> {
  render() {
    return (
      <Box
        css={merge.all([
          root,
          containerStyle(this.props),
          this.props.css || {}
        ])}
      >
        {this.props.children}
      </Box>
    )
  }
}

const containerStyle = props => {
  let style: any = {
    margin: 'auto'
  }
  if (props.fluid) {
    style.width = '100%'
  } else {
    if (props.maxWidth) {
      style.maxWidth = props.maxWidth + 'px'
    }
  }
  return style
}

export default Container
